import { createUseStyles } from 'react-jss';

import { Spacings, Transitions } from '@picsart/rc/enums';
import { FontSizes, FontWeights } from '@picsart/rc/fonts';
import { textOverflowHidden } from '@picsart/rc/helpers';
import {
  canHover,
  isLeftToRight,
  isRightToLeft,
} from '@picsart/design-system/foundation/styleHelpers';

const useStyles = createUseStyles(
  {
    root: {
      position: 'relative',
      display: 'flex',
      height: 44,
      marginBottom: `${Spacings.Size_6}px`,

      [isLeftToRight]: {
        paddingLeft: 52,
      },
      [isRightToLeft]: {
        paddingRight: 52,
      },

      '&:last-child': {
        marginBottom: 0,
      },

      [canHover]: {
        '&:hover': {
          cursor: 'pointer',
        },
      },

      '&.compact': {
        padding: 0,
        marginBottom: 0,
        width: 48,
        height: 48,
        alignItems: 'center',
        justifyContent: 'center',
      },
    },
    copyButtonTitle: {
      display: 'block',
      flex: '1 1 auto',
      fontWeight: FontWeights.SemiBold,
      fontSize: FontSizes.Size_6,
      color: '#282B36',
      ...textOverflowHidden,
      textTransform: 'capitalize',
      lineHeight: '44px',
    },
    copyButtonIconHolder: {
      '&:before': {
        content: '""',
        width: 27,
        height: 27,
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        borderRadius: '50%',
        backgroundColor: '#EDEEF4',
        zIndex: -1,
      },

      '&.general': {
        maxWidth: 24,
        '& > svg': {
          '& > path': {
            fill: '#282B36',
            transition: `fill ${Transitions.Default} ease-in-out`,
          },
        },
      },

      '&:not(.compact)': {
        width: 24,
        height: 24,
        position: 'absolute',
        overflow: 'visible',
        top: '50%',
        transform: 'translateY(-50%)',
      },

      '&.compact': {
        left: 'auto',

        '&:before': {
          width: 36,
          height: 36,
        },
      },

      [isLeftToRight]: {
        left: 6,
      },
      [isRightToLeft]: {
        right: 6,
      },
    },
  },
  {
    name: 'copy-button',
  },
);

export default useStyles;
